import { useTranslation } from "react-i18next";

import { BoxWrapper } from "../../../../../../../components";
import { addStyles } from "./addStyles";

import {
  ButtonStyled,
  Item,
  List,
  Text,
  Title,
  WrapperRoot,
} from "./PopularQueries.styled";

export const PopularQueries = ({ setUrl, mainPageData }) => {
  const { t } = useTranslation();

  return (
    <WrapperRoot>
      <BoxWrapper addStyles={addStyles}>
        <Title>{t("global.popularQueries")}</Title>
        <>
          <List>
            {mainPageData.popularUrls.map((query, idx) => (
              <Item key={idx}>
                <ButtonStyled onClick={() => setUrl(query)}>
                  <Text>{query}</Text>
                </ButtonStyled>
              </Item>
            ))}
          </List>
        </>
      </BoxWrapper>
    </WrapperRoot>
  );
};
